import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"margin":"6px 8px"} }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "flex sm4 md3" }
const _hoisted_4 = { class: "flex sm4 md3" }
const _hoisted_5 = { class: "mdo-select" }
const _hoisted_6 = { for: "sort" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "flex xs6" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mr-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Conta Inativa ")

import {Account, AccountSearchInput, FilterScopeEnum, SortAccountInput, SortOrderEnum} from "@/codes/gen/types";
import {AccountService} from "@/codes/services/AccountService";
import {ReactiveData} from "@/codes/types/MDOTypes";
import {DEFAULT_ITEMS_PER_PAGE, ROUTE_NAMES, VUEX_ACTIONS} from "@/codes/util/constants";
import {calculatePageCount, hasWritePermission} from "@/codes/util/functions";
import {Confirm} from "@/codes/util/swalUtil";
import router from "@/router";
import store from "@/store";
import {onMounted, reactive, ref} from "vue";
import {useI18n} from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loadingAccounts = ref(false);
let page = 1;
const pageCount = ref(1);
const service = new AccountService();
const itemsPerPage = ref(DEFAULT_ITEMS_PER_PAGE);
const accounts = reactive<ReactiveData<Account[]>>({ data: [] as Account[] });
const filterParamsDefault: AccountSearchInput = {
  page: page,
  perPage: itemsPerPage.value, 
  scope: FilterScopeEnum.WithTrashed,
  sort: {
    name: SortOrderEnum.Asc
  }
}

let pageLoaded = 0;

const i18n = useI18n();

const headers = reactive({ data: [
  { key: 'name', label: i18n.t('register.name') },
  { key: 'cnpj', label: i18n.t('account.cnpj') },
  { key: 'email', label: i18n.t('register.email') },
  { key: 'phone', label: i18n.t('register.phone') },
  { key: 'whatsapp', label: i18n.t('register.whatsapp') }
]});

const filter = reactive<ReactiveData<AccountSearchInput>>({
  data: {
    q: '',
    sort: {name: SortOrderEnum.Asc} as SortAccountInput,
    scope: FilterScopeEnum.WithTrashed,
  } as AccountSearchInput
});

const checkHasWritePermission = function() {
  if (hasWritePermission(ROUTE_NAMES.accounts)) {
    headers.data.push({ key: 'actions', label: i18n.t('form.actions')  });
  }
}

const loadAccounts = async function(filter: AccountSearchInput) {
  accounts.data = [];
  loadingAccounts.value = true;

  const accountsEdge = await service.getAll(filter);
  if (accountsEdge) {
    pageCount.value = calculatePageCount(itemsPerPage.value, accountsEdge.pagination?.total ?? 1);
    accounts.data = accountsEdge.edges;
    pageLoaded = page;
  }
  loadingAccounts.value = false;
}

const optionsSort = reactive({ data: [
    {
      text: 'Data (recentes)',
      value: { createdAt: SortOrderEnum.Desc }
    },
    {
      text: 'Data (antigos)',
      value: { createdAt: SortOrderEnum.Asc }
    },
    {
      text: 'Nome (ordem alfabética inversa)',
      value: { name: SortOrderEnum.Desc }
    },
    {
      text: 'Nome (ordem alfabética)',
      value: { name: SortOrderEnum.Asc }
    },
  ] as any });

const executeFilter = function() {

  let hasFilter = false;
  const f: AccountSearchInput = {
    q: '',
    sort: {} as SortAccountInput,
    scope: FilterScopeEnum.WithTrashed
  };

  if (!filter.data.q && !filter.data.sort) {
    return;
  }

  if (filter.data.q) {
    hasFilter = true;
    f.q = filter.data.q;
  }

  if (filter.data.sort) {
    hasFilter = true;
    f.sort = filter.data.sort;
  }else{
    f.sort = {  name: SortOrderEnum.Asc };
  }
  if (hasFilter) {
    loadAccounts(f);
  } else {
      loadAccounts(filterParamsDefault);
  }
}


const cleanFilter = function() {
  filter.data = {
    q: ''
  } as AccountSearchInput

  loadAccounts(filterParamsDefault)
}

const onPageChanged = function(newPage: number) {
  page = newPage;
  loadAccounts(filterParamsDefault);
}

onMounted(() => {
  loadAccounts(filterParamsDefault);

  store.subscribeAction({
    after: (action) => {
      if (action.type === VUEX_ACTIONS.setUserInfo) {
        checkHasWritePermission();
      }
    }
  });

  checkHasWritePermission();
});

const doNew = function() {
  router.push({ name: ROUTE_NAMES.newAccount });
};

const edit = function(id: string) {
  router.push({ name: ROUTE_NAMES.editAccount, params: { id: id }});
}

const doRemove = async function(id: string) {
  const result = await service.remove(id);
  if (result && result.data.id) {
      executeFilter();
  }
}

const doRestore = async function(id: string) {
  const result = await service.restore(id);
  if (result && result.data.id) {
      executeFilter();
  }
}



function remove(account: Account) {
  Confirm.fire({
    title: "Desativar conta",
    text: `Deseja realmente desativar a conta ${account.name}`
  })
  .then((result) => {
    if (result.isConfirmed) {
      doRemove(account.id);
    }
  })
}
function restore(account: Account) {
  Confirm.fire({
    title: "Reativar conta",
    text: `Deseja realmente reativar a conta ${account.name}`
  })
  .then((result) => {
    if (result.isConfirmed) {
      doRestore(account.id);
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_VField = _resolveComponent("VField")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_accordion = _resolveComponent("va-accordion")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_data_table = _resolveComponent("va-data-table")!
  const _component_base_list = _resolveComponent("base-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_list, {
      page: _unref(page),
      "page-count": pageCount.value,
      "current-route": _unref(ROUTE_NAMES).accounts,
      "page-loaded": _unref(pageLoaded),
      "show-delete": false,
      "has-filter": true,
      onPageChanged: onPageChanged,
      onDoNew: doNew
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_va_accordion, { style: {"max-width":"100%"} }, {
            default: _withCtx(() => [
              _createVNode(_component_va_collapse, {
                header: _ctx.$t('list.filters')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_card_content, { style: {"background-color":"var(--va-collapse-header-content-background-color)"} }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_VField, { name: "q" }, {
                                default: _withCtx(({ field}) => [
                                  _createVNode(_component_va_input, _mergeProps(field, {
                                    modelValue: _unref(filter).data.q,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(filter).data.q = $event)),
                                    class: "mb-4",
                                    outline: "true",
                                    label: "Buscar",
                                    type: "search"
                                  }), null, 16, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('list.sort')), 1),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(filter).data.sort = $event)),
                                  name: "sort"
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(optionsSort).data, (op) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: op.value,
                                      value: op.value
                                    }, _toDisplayString(op.text), 9, _hoisted_7))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _unref(filter).data.sort]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_va_button, {
                                color: "info",
                                onClick: executeFilter
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('list.executeFilter')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_va_button, {
                                class: "ml-3",
                                color: "warning",
                                onClick: cleanFilter
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('list.cleanFilter')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_va_data_table, {
          items: _unref(accounts).data,
          columns: _unref(headers).data,
          "sticky-header": "",
          loading: loadingAccounts.value,
          "no-data-html": "Sem resultados",
          style: _normalizeStyle({
          '--va-data-table-scroll-table-color': 'var(--va-divider)',
        })
        }, {
          "cell(name)": _withCtx(({ rowData }) => [
            _createElementVNode("div", {
              class: "pointer flex flex-row",
              onClick: ($event: any) => (edit(rowData.id))
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(rowData.name), 1),
              (rowData.deletedAt)
                ? (_openBlock(), _createBlock(_component_va_chip, {
                    key: 0,
                    outline: "",
                    color: "warning",
                    size: "small",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (rowData.disabledBySaas)
                ? (_openBlock(), _createBlock(_component_va_icon, {
                    key: 1,
                    color: "danger",
                    name: "warning"
                  }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_9)
          ]),
          "cell(actions)": _withCtx(({ rowData }) => [
            _createVNode(_component_va_button, {
              icon: "fas fa-edit",
              class: "mr-1",
              color: "info",
              size: "small",
              onClick: ($event: any) => (edit(rowData.id))
            }, null, 8, ["onClick"]),
            (!rowData.deletedAt)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  icon: "fas fa-trash",
                  class: "danger",
                  size: "small",
                  onClick: ($event: any) => (remove(rowData))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (rowData.deletedAt)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  icon: "fas fa-repeat",
                  color: "warning",
                  class: "warning",
                  size: "small",
                  onClick: ($event: any) => (restore(rowData))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["items", "columns", "loading", "style"])
      ]),
      _: 1
    }, 8, ["page", "page-count", "current-route", "page-loaded"])
  ]))
}
}

})